import React from 'react';
import { StyledSelect } from '../../../../../Dispatch/RouteExecution/Pickups/PickupManagement/components/Select';
import { Button } from '@material-ui/core';
import { ACTIVE_DETAILS } from '../../../constants';

const HeaderAction = ({
  driverData,
  classes,
  handleRouteChange,
  activeDetail,
  onActivePageChange,
  route
}) => {
  const manifestOptions = driverData.routes.map((route) => {
    return { label: route.manifestNumber, value: route.routeId };
  });
  return (
    <>
      <div className={classes.manifestClass}>
        <StyledSelect
          textFieldProps={{
            id: 'manifestNumber',
            label: 'Manifest Number',
            variant: 'outlined'
          }}
          value={route.manifestNumber}
          onChange={handleRouteChange}
          data={manifestOptions}
          isNotClearable
        />
      </div>

      <Button
        variant="outlined"
        size="small"
        className={classes.actionButtonClass}
        onClick={onActivePageChange}
        color="primary">
        {activeDetail === ACTIVE_DETAILS.STOP ? 'Route Details' : 'Stop Details'}
      </Button>
    </>
  );
};

export default HeaderAction;
